import { AnimatePresence, motion } from 'motion/react'
import { useStore } from '../../store'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { Topbar } from './Topbar'
import { Rail } from './Rail'
import { Sidebar } from '../sidebar/Sidebar'
import { Conversation } from '../chat/Conversation'
import { PortfolioPage } from '../portfolio/PortfolioPage'
import { SettingsPage } from '../settings/SettingsPage'
import { TasksPage } from '../tasks/TasksPage'
import { TaskEditorHost } from '../tasks/TaskEditor'
import { WorkersPage } from '../workers/WorkersPage'
import { Calculator } from '../calculator/Calculator'
import { MemoryPanel } from '../memory/MemoryPanel'
import { AdminPanel } from '../admin/AdminPanel'
import { SymbolModal } from '../symbol/SymbolModal'
import { SymbolPalette } from '../symbol/SymbolPalette'
import { Orb } from '../orb/Orb'

export function AppShell() {
  const sidebarOpen = useStore((s) => s.sidebarOpen)
  const toggleSidebar = useStore((s) => s.toggleSidebar)
  const view = useStore((s) => s.view)
  const isMobile = useMediaQuery('(max-width: 767px)')

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <Topbar />
      <div className="relative flex min-h-0 flex-1">
        <Rail />

        {/* Desktop: sidebar docks inline and pushes the conversation. */}
        {!isMobile && (
          <AnimatePresence initial={false}>
            {sidebarOpen && (
              <motion.div
                initial={{ width: 0, opacity: 0 }}
                animate={{ width: 272, opacity: 1 }}
                exit={{ width: 0, opacity: 0 }}
                transition={{ duration: 0.24, ease: [0.32, 0.72, 0, 1] }}
                className="overflow-hidden"
              >
                <Sidebar />
              </motion.div>
            )}
          </AnimatePresence>
        )}

        {view === 'portfolio' ? (
          <PortfolioPage />
        ) : view === 'settings' ? (
          <SettingsPage />
        ) : view === 'tasks' ? (
          <TasksPage />
        ) : view === 'workers' ? (
          <WorkersPage />
        ) : (
          <Conversation />
        )}

        {/* Mobile: sidebar is an overlay drawer with a backdrop. */}
        {isMobile && (
          <AnimatePresence>
            {sidebarOpen && (
              <>
                <motion.div
                  key="backdrop"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  onClick={() => toggleSidebar(false)}
                  className="absolute inset-0 z-30 bg-black/55"
                />
                <motion.div
                  key="drawer"
                  initial={{ x: '-100%' }}
                  animate={{ x: 0 }}
                  exit={{ x: '-100%' }}
                  transition={{ type: 'spring', stiffness: 380, damping: 38 }}
                  className="absolute inset-y-0 left-0 z-40 shadow-[var(--e-3)]"
                >
                  <Sidebar />
                </motion.div>
              </>
            )}
          </AnimatePresence>
        )}
      </div>
      <Orb />
      <Calculator />
      <MemoryPanel />
      <AdminPanel />
      <SymbolModal />
      <SymbolPalette />
      <TaskEditorHost />
    </div>
  )
}
